import Iconify from '@iconify/iconify';
import Swiper, {Autoplay, EffectFade, Navigation, Thumbs} from 'swiper';
import * as Vue from 'vue';

require('./fonts.js');
window._ = require('lodash');
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.Vue = Vue;
window.Exposure = Vue.defineAsyncComponent(() =>
    import('./components/Exposure.vue')
);
window.ConfirmForm = Vue.defineAsyncComponent(() =>
    import('./components/ConfirmForm.vue')
);

Swiper.use([Autoplay, EffectFade, Navigation, Thumbs]);
window.Swiper = Swiper;

if (document.querySelector('.nav__button')) {
    const nav_button = document.querySelector('.nav__button');

    nav_button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.toggle('nav--open');
    });
}

window.Snackbar = require("snackbarlightjs");
